export default (filterState) =>
    Object.keys(filterState.applied).reduce((obj, key) => {
        const values = filterState.applied[key];
        if (!values || (key === 'customFilters' && values.length === 0)) {
            return obj;
        }
        return { ...obj, [key]: filterState.applied[key] };
    }, {});
